import React, { useEffect, useRef, useState } from 'react';
import { colors } from '../../../../colorVars';
import { checkSymbol } from '../../../../stores/websocketStore/utils/async/checkSymbol';
import style from './SymbolInput.module.css';
type Props = {
  stateSetterFunction: (value: string) => void;
  initialValue: string;
  brokerage: string;
  fontSize: string;
  color:
    | 'blue'
    | 'green'
    | 'white'
    | 'red'
    | 'grey'
    | 'lightGrey'
    | 'black'
    | 'orange'
    | 'yellow'
    | 'purple';
  backgroundColor:
    | 'blue'
    | 'green'
    | 'white'
    | 'red'
    | 'grey'
    | 'lightGrey'
    | 'black'
    | 'orange'
    | 'yellow'
    | 'purple';
  width?: string;
  margin?: string;
};

export const SymbolInput = ({
  stateSetterFunction,
  initialValue,
  brokerage,
  color,
  backgroundColor,
  fontSize,
  width,
  margin,
}: Props) => {
  const [inputValue, setInputValue] = useState('');
  const [isLegit, setIsLegit] = useState(true);
  const latestValidationRequestRef = useRef('');

  const highLightClick = (e) => {
    e.target.select();
  };

  useEffect(() => {
    setInputValue(initialValue ?? '');
  }, [initialValue]);

  useEffect(() => {
    const normalizedInput = String(inputValue ?? '')
      .trim()
      .toUpperCase();

    if (!normalizedInput) {
      setIsLegit(true);
      latestValidationRequestRef.current = '';
      return;
    }

    if (!brokerage) {
      setIsLegit(true);
      return;
    }

    let cancelled = false;
    latestValidationRequestRef.current = normalizedInput;
    checkSymbol({ symbolString: normalizedInput, brokerage }).then((json) => {
      if (cancelled || latestValidationRequestRef.current !== normalizedInput) {
        return;
      }
      setIsLegit(!!json.exists);
    });

    return () => {
      cancelled = true;
    };
  }, [inputValue, brokerage]);
  return (
    <input
      placeholder="symbol..."
      style={{
        color: colors[color],
        backgroundColor: colors[backgroundColor],
        fontSize,
        width,
        margin,
      }}
      className={isLegit ? style.isLegit : style.isNotLegit}
      type="text"
      value={inputValue}
      onChange={({ target }) => {
        setIsLegit(true);
        setInputValue(target.value);
      }}
      onBlur={() => {
        const normalizedInput = String(inputValue ?? '')
          .trim()
          .toUpperCase();
        if (normalizedInput !== inputValue) {
          setInputValue(normalizedInput);
        }
        stateSetterFunction(normalizedInput);
      }}
      onKeyDown={(event) => {
        if (event.key === 'Enter') {
          event.currentTarget.blur();
        }
      }}
      onClick={highLightClick}
    />
  );
};
